export default {
  SET_NOTIFICATIONS(state, pl) {
    state.items = pl;
  }
};
